import { stationOpsApi } from "../config/apiConfig";
import { ExclusionResult, StationExclusion } from "../types/alerting";

const BASE = "/internal/station-exclusions";

const toExclusion = (raw: any): StationExclusion => ({
  stationId: raw.station_id,
  stationName: raw.station_name ?? null,
  stationFound: raw.station_found,
  published: raw.published ?? null,
  note: raw.note ?? null,
  excludedAt: raw.excluded_at,
  excludedForSeconds: raw.excluded_for_seconds,
  excludedBy: raw.excluded_by,
});

/** Lists the stations whose owners are currently not alerted, newest first. */
export const listExclusions = async (): Promise<StationExclusion[]> => {
  const response = await stationOpsApi.get(BASE);
  return (response.data?.content ?? []).map(toExclusion);
};

/** Excludes several stations at once; each gets its own outcome, since the call is not all-or-nothing. */
export const excludeStations = async (
  stationIds: string[],
  note: string | null,
): Promise<ExclusionResult[]> => {
  const response = await stationOpsApi.post(BASE, { station_ids: stationIds, note });
  return (response.data?.results ?? []).map((raw: any) => ({
    stationId: raw.station_id,
    outcome: raw.outcome,
  }));
};

/** Sets or clears the note on a station's active exclusion. */
export const updateExclusionNote = async (
  stationId: string,
  note: string | null,
): Promise<StationExclusion> => {
  const response = await stationOpsApi.patch(`${BASE}/${encodeURIComponent(stationId)}`, { note });
  return toExclusion(response.data);
};

/** Returns a station to normal alerting from the next sweep. Idempotent on the server. */
export const removeExclusion = async (stationId: string): Promise<void> => {
  await stationOpsApi.delete(`${BASE}/${encodeURIComponent(stationId)}`);
};
